// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, ComponentProps } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import style from 'react-syntax-highlighter/dist/esm/styles/prism/darcula';
import gfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';

function NoTranslate(props: ComponentProps<'div'>) {
  return <div translate="no" {...props} />
}

const S = {
  ReactMarkdown: styled(ReactMarkdown)<ReactMarkdown.ReactMarkdownProps>`
    /* Global Setting */
    * {
      font-size: 16px;
      line-height: 23px;
      color: #434343;
    }
    /* Disable select */
    * {
      user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      -moz-user-select: none;
      -webkit-touch-callout: none;
      -webkit-user-drag: auto;
    }

    /* margins */
    > * + * {
      margin-top: 15px;
    }

    li > :not(ol):not(ul) + :not(ol):not(ul) {
      /* margin-top: 30px; */
    }

    h1, h2, h3, h4, h5, h6 {
      & + * {
        margin-top: 12px;
      }
    }

    /* Header Styles */
    h1 {
      font-weight: bold;
      font-size: 32px;
      line-height: 46px;
      color: #666666;
    }

    h2 {
      font-weight: 400;
      font-size: 16px;
      line-height: 23px;
      color: #434343;
    }

    h3 {
      // font-size: 20px;
      // line-height: 29px;
      // color: #434343;
      font-weight: 400;
      font-size: 16px;
      line-height: 23px;
      color: #434343;
    }

    em {
      color: #EF8200;
    }

    code {
      display: inline-block;
      padding: 2px 6px;
      margin: 0 2px;
      background-color: #f0f0f0;
      border-radius: 4px;
      line-height: 22px;

      &, * {
        font-family: Consolas, monaco, monospace !important;
        user-select: text;
        -webkit-user-select: text;
        -ms-user-select: text;
        -moz-user-select: text;
        -webkit-touch-callout: revert;
        -webkit-user-drag: auto;

        .linenumber {
          user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          -moz-user-select: none;
        }
      }
    }

    img {
      margin-top: 20px;
    }

    pre {
      margin-top: 12px;
      padding: 8px 12px;
      border-radius: 2px;
      background-color: #f0f0f0;
      white-space: normal;
    }

    a {
      color: #EF8200;
      text-decoration: underline;

      * {
        color: #EF8200;
        text-decoration: underline;
      }
    }

    strong {
      font-weight: bold;

      * {
        font-weight: bold;
      }
    }

    ul {
      margin-left: 20px;
    }

    ol {
      margin-left: 18px;

      li {
        padding-left: 2px;
      }
    }

    ul {
      list-style-type: revert;
    }

    ol {
      list-style-type: revert;
    }

    & > ol, & > ul {
      ol, ul {
        margin-left: 30px;
      }
    }

    li {
      > img:nth-child(n+2) {
        margin-top: 12px;
      }

      > img:nth-last-child(n+2) {
        margin-bottom: 12px;
      }
    }

    blockquote {
      padding: 4px 12px;
      background: rgba(255, 245, 6, 0.1);
      border-left: 8px solid #FFF506;
    }

    table {
      margin: 16px 0;
      color: #303030;
      border: 0;
      width: auto;
      display: block;
      overflow-x: auto;
      border-collapse: collapse;

      tr th {
        background-color: #f0f0f0;
        border-bottom: solid 2px #bfbfbf;
      }

      tr td, tr th {
        border: 1px solid #dbdbdb;
        padding: 10px 16px;
        line-height: 20px;
        vertical-align: middle;
      }

      tbody {
        background-color: #fff;
      }
    }
  `,
  Wrapper: styled(NoTranslate)`
    width: 100%;
    padding-bottom: 10px;
  `,
  WrapperLeft: styled.div`
    flex: 1;
    margin-right: 100px;
  `,
  LabInfoTitleSection: styled.div`
    padding: 0 30px;

    h1 {
      margin-bottom: 14.38px;
    }
  `,
  Img: styled.img`
    max-width: 70%;
    display: flex;
  `
};

function handleContextMenu(e: React.MouseEvent<HTMLElement>) {
  const allow = ['A', 'PRE', 'CODE']
  if (allow.includes((e.target as HTMLElement).tagName)) {
    e.stopPropagation();
  } else {
    e.preventDefault();
  }
}

const Image = (props: ComponentPropsWithRef<'img'>): JSX.Element => {
  return <S.Img
    alt=""
    {...props}
    draggable={false}
  />
}

export interface MarkdownProps extends ComponentPropsWithRef<'div'> {
  markdown: string;
  baseUrl?: string;
  imgUrl?: string;
  id?: string;
}

interface CodeProps extends React.ComponentPropsWithRef<'code'> {
  value: string;
  language: string;
}

const Code = ({ value = '', language }: CodeProps): JSX.Element => {
  return <SyntaxHighlighter
    style={{ ...style, backgroundColor: '' }}
    customStyle={{ backgroundColor: '' }}
    language={language}
    showLineNumbers={true}
  >
    {value.trimEnd()}
  </SyntaxHighlighter>
}

const Markdown = ({ markdown, baseUrl, imgUrl, id, ...props }: MarkdownProps): JSX.Element => {
  const uriParser = (uri: string) => {
    return uri.indexOf('./') === 0 ? `${imgUrl}/${uri.slice(2)}` : uri
  }
  const markdownParsed = (markdown: string) => {
    // return markdown.replace(/\$\{s3Url\}/g, `${baseUrl}`).replace(/\$\{password\}/g, `${challengePassword}`)
    return markdown.replace(/\$\{s3Url\}/g, `${baseUrl}`)
  }
  const Link = (props: ComponentPropsWithRef<'a'>): JSX.Element => {
    const url = props.href?.[0] === '.' ? baseUrl + props.href : props.href;
    return <a {...props} target="_blank" href={url} rel="noreferrer" onContextMenu={handleContextMenu} />
  }

  const ParsedHtml = ({ value }: any) => {
    const commentTagRegex = new RegExp(/<!--(?:.|\n|\r)*?-->/g)
    const imageTagRegex = new RegExp(/<img src="([^"]+)"/g)

    const sanitizedValue = value.replace(commentTagRegex, '');
    const result = imageTagRegex.exec(sanitizedValue) || [];

    if (result[1]) {
      return <S.Img
        alt="challenge-img"
        src={`${uriParser(result[1])}`}
        draggable={false}
        onContextMenu={(handleContextMenu)}
      />
    }

    return (
      <div dangerouslySetInnerHTML={{ __html: value }} />
    );
  }

  const renderers = {
    image: Image,
    link: Link,
    html: ParsedHtml,
    code: Code,
  }

  return (
    <S.Wrapper
      data-testid="challenge-experiment"
      className="view-all-content-wrapper-challenge"
      id={id}
      onContextMenu={handleContextMenu}
      {...props}
    >
      <S.ReactMarkdown
        source={markdownParsed(markdown)}
        transformImageUri={uriParser}
        transformLinkUri={uriParser}
        renderers={renderers}
        plugins={[gfm]}
      />
      {
        markdown ? '' : (
          <S.WrapperLeft
            className="wrapper-left"
            dangerouslySetInnerHTML={{ __html: markdownParsed(markdown) }}
          />
        )
      }
    </S.Wrapper>
  );
}

export default React.memo(Markdown);
